export enum Size {
    SMAL = '200px',
    MEDIUM = '600px',
    LARGE = '700px'
}
